<script setup>
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState'

const {
  rowsFiltered,
  allowImageFallback,
  nearestParentCategorySmallImageUrl,
  selectArticle,
} = useCatalogState();
</script>

<template>
  <!-- Display mode: grid -->
  <div class="relative grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 w-full mt-2 mb-32">
    <a href="#" v-for="(row, i) in rowsFiltered" @click.prevent="selectArticle(row)" class="p-6 bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
      <!-- Article image -->
      <div class="mb-4">
        <div class="w-full text-center aspect-square grid place-items-center dark:bg-white dark:p-3 dark:rounded-md" v-if="row.smallImageUrl || row.thumbnailUrl">
          <img :src="row.smallImageUrl || row.thumbnailUrl" alt="" class="rounded" style="max-height: 120px;" />
        </div>
        <div class="w-full text-center aspect-square grid place-items-center dark:bg-white dark:p-3 dark:rounded-md" v-else-if="allowImageFallback && nearestParentCategorySmallImageUrl">
          <img :src="nearestParentCategorySmallImageUrl" alt="" class="rounded" style="max-height: 120px;" />
        </div>
        <!-- :class="{ 'text-blue-200': selectedItemId == row.id && promptDeleteItemId != row.id, 'text-red-300': promptDeleteItemId == row.id }" -->
        <div class="grid place-items-center text-gray-200 dark:text-gray-900 text-center w-full aspect-square" style="font-size: 108px;" v-else>
          <i class="fa fa-image"></i>
        </div>
      </div>

      <!-- Article name and SKU -->
      <h3 class="text-sm tracking-tight text-blue-700 dark:text-blue-300 mb-1" v-if="row.sku">{{ row.sku }}</h3>
      <h5 class="text-sm tracking-tight text-gray-900 dark:text-white">{{ row.name }}</h5>
    </a>
  </div>
</template>